var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-box",attrs:{"name":"kakao-button"}},[_c('div',{staticClass:"button",on:{"click":_vm.btnClick}},[_c('img',{staticClass:"image",attrs:{"src":require("../../assets/kakao.png")}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("카카오 채팅상담")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43774a7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/KakaoButton.vue
// module id = null
// module chunks = 